<div #modal class="flex flex-col flex-auto bg-white" *screenSizes="let size" [matDialogFullscreen]="fullscreen">
  <div #titleContainer mat-dialog-title class="flex items-center justify-between text-on-primary bg-primary mb-0 px-4 py-2">
    <ng-content select="[svc-dialog-title]"></ng-content>

		<button class="close-button -mr-1 print:hidden" mat-icon-button (click)="closeDialog()" [svcTestId]="testIdFor('btn--close-header')">
			<mat-icon class="text-current icon-size-8" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
		</button>

  </div>

  <div class="flex-auto overflow-auto" [style.height]="needInternalScroll && scrollInsideContent ? 'calc(100dvh - ' +  ((titleContainer?.offsetHeight ?? 0) + (actionsContainer?.offsetHeight ?? 0)) + 'px)' : null">
    <ng-content select="[svc-dialog-content]" mat-dialog-content></ng-content>
  </div>

  <div #actionsContainer mat-dialog-actions align="end" class="bg-primary text-on-primary p-4">

    <ng-content select="[svc-dialog-actions-options]">
    </ng-content>

    <ng-container [ngSwitch]="dialogStyle">

      <div *ngSwitchCase="'form'" class="flex flex-row gap-2">
        <!-- Menu button -->
        <ng-container *ngIf="hasItemsToShowMenu">
          <button mat-icon-button [matMenuTriggerFor]="matMenuActions" aria-label="Ações na visualização quando for administrador">
            <mat-icon class="text-current" [svgIcon]="'heroicons_solid:ellipsis-vertical'"></mat-icon>
          </button>
          <mat-menu [xPosition]="'before'" #matMenuActions="matMenu">
            <button mat-menu-item (click)="remove()" *ngIf="showMatMenu?.delete">
              <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
              <span class="text-base">{{ 'Remover' | transloco }}</span>
            </button>
            <button mat-menu-item (click)="resend()" *ngIf="showMatMenu?.resend">
              <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:arrow-path'"></mat-icon>
              <span class="text-base">{{ 'Reenviar' | transloco }}</span>
            </button>
            <button mat-menu-item (click)="reschedule()" *ngIf="showMatMenu?.reschedule">
              <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:clock'"></mat-icon>
              <span class="text-base">{{ 'Reprogramar' | transloco }}</span>
            </button>
            <button mat-menu-item (click)="close()" *ngIf="showMatMenu?.close">
              <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:x-circle'"></mat-icon>
              <span class="text-base">{{ 'Encerrar' | transloco }}</span>
            </button>
            <button mat-menu-item (click)="setEditMode()" *ngIf="showMatMenu?.edit">
              <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
              <span class="text-base">{{ 'Editar' | transloco }}</span>
            </button>
            <button mat-menu-item (click)="view()" *ngIf="showMatMenu?.view">
              <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
              <span class="text-base">{{ 'Ver' | transloco }}</span>
            </button>
          </mat-menu>
        </ng-container>

        <button
          svc-outlined-btn
          type="button"
          color="on-primary"
          id="svc-dialog-primary-button-cancel"
          [disabled]="disableCancel"
          (click)="closeDialog()"
          [svcTestId]="testIdFor('btn--cancel')"
        >
          {{ textCancel ?? ('Cancelar' | transloco) }}
        </button>

        <button
          svc-filled-btn
          type="button"
          color="on-primary"
          id="svc-dialog-primary-button-save"
          [disabled]="disableConfirm"
          [processing]="processing"
          (click)="confirmed.emit()"
          [svcTestId]="testIdFor('btn--save')"
        >
          {{ textConfirm ?? ('Salvar' | transloco) }}
        </button>
      </div>

      <div *ngSwitchCase="'close'">
        <button
          svc-filled-btn
          type="button"
          color="on-primary"
          id="svc-dialog-primary-button-close"
          [disabled]="disableCancel"
          (click)="closeDialog()"
          [svcTestId]="testIdFor('btn--close')"
        >
          {{ textCancel ?? ('Fechar' | transloco) }}
        </button>
      </div>
    </ng-container>

  </div>

</div>
